import React from 'react';
import Index11 from "../pages/GYM/Index11";
import WorkoutPage from "../pages/GYM/WorkoutPage";
import ProfilePage from "../pages/GYM/ProfilePage";
import ProgramSuccessPage from "../pages/GYM/ProgramSuccessPage";
import ForgotPasswordPage from "../pages/GYM/ForgotPasswordPage";
import ResetPasswordPage from "../pages/GYM/ForgotPasswordPage";
import AuthRequiredRoute from "../components/AuthRequiredRoute";

const routes = [
  // Main landing page
  { path: "/", component: <Index11 /> },
  
  // Profile route
  { path: "/profile", component: <ProfilePage /> },
  
  // Program Success page
  { path: "/program-success", component: <ProgramSuccessPage /> },
  
  // Authentication pages
  { path: "/forgot-password", component: <ForgotPasswordPage /> },
  { path: "/reset-password/:token", component: <ResetPasswordPage /> },
  
  // Discipline pages - passing required props to WorkoutPage
  {
    path: "/strength-training",
    component: <WorkoutPage
      equipment="full"
      formattedDiscipline="Strength Training"
      fitnessLevel="intermediate"
      duration={60}
      goal="muscle building"
    />
  },
  {
    path: "/crossfit",
    component: <WorkoutPage
      equipment="full"
      formattedDiscipline="CrossFit"
      fitnessLevel="advanced"
      duration={45}
      goal="overall fitness"
    />
  },
  {
    path: "/powerlifting",
    component: <WorkoutPage
      equipment="full"
      formattedDiscipline="Powerlifting"
      fitnessLevel="advanced"
      duration={75}
      goal="strength development"
    />
  },
  {
    path: "/bodybuilding",
    component: <WorkoutPage
      equipment="full"
      formattedDiscipline="Bodybuilding"
      fitnessLevel="intermediate"
      duration={60}
      goal="muscle hypertrophy"
    />
  },
  {
    path: "/hyrox",
    component: <WorkoutPage
      equipment="limited"
      formattedDiscipline="Hyrox"
      fitnessLevel="advanced"
      duration={45}
      goal="functional fitness"
    />
  },
  {
    path: "/yoga",
    component: <WorkoutPage
      equipment="none"
      formattedDiscipline="Yoga"
      fitnessLevel="beginner"
      duration={45}
      goal="flexibility and mindfulness"
    />
  },
  {
    path: "/home-workouts",
    component: <WorkoutPage
      equipment="limited"
      formattedDiscipline="Home Workouts"
      fitnessLevel="beginner"
      duration={30}
      goal="general fitness"
    />
  },
];

export { routes };